module.exports = __webpack_public_path__ + "static/media/savio9.fc09d844.jpg";